import { render, staticRenderFns } from "./PlmSample.vue?vue&type=template&id=7d859f7e"
import script from "./PlmSample.vue?vue&type=script&lang=js"
export * from "./PlmSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports